import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelectionData, resolveMetricValue } from '../../services/useSelectionData';
import { formatPlace, getNarrativeScope, renderNarrative } from '../../services/metricNarratives';
const SECTION_LABEL_CLASS = 'd-block text-uppercase fw-semibold mb-2 h6';
/**
 * The sidebar card body's "Workforce Insights" section — paragraphs describing
 * the selection at the current geography with live values substituted in and
 * emphasized. Values come from the same resolver the KPI header uses, so the
 * panel and the chips above the map can never disagree.
 *
 * The per-category definition and the data-source attribution both render in
 * the card header (MapDashboard), not here — the attribution moved there as the
 * "i Data source" popover. It still keys off getNarrativeScope, so it cannot
 * cite county sources while these paragraphs describe the state.
 *
 * The supervision ratio card is deliberately NOT rendered here. It is a sibling
 * of the whole sidebar panel in MapDashboard, because nesting it inside the
 * panel breaks printing — see the note on .narrative-side in dashboard.css.
 */
const MetricNarrative = ({ dashboardState }) => {
    const { countyData, stateData, isLoading } = useSelectionData(dashboardState);
    const scope = getNarrativeScope(dashboardState);
    const resolve = (metricId) => resolveMetricValue(dashboardState, countyData, stateData, metricId);
    const narrative = isLoading
        ? null
        : renderNarrative({
            groupId: dashboardState.selectedGroupId,
            categoryId: dashboardState.selectedCategoryId,
            metricId: dashboardState.selectedMetricId,
            scope,
            place: formatPlace(dashboardState),
            countySelected: dashboardState.selectedCounty != null,
            resolve
        });
    let insightsTitle = "Workforce Insights";
    if (dashboardState.selectedGroupId === 'workforce') {
        insightsTitle = "Workforce Insights";
    }
    else if (dashboardState.selectedGroupId === 'adjacent') {
        insightsTitle = "Adjacent Fields Insights";
    }
    else if (dashboardState.selectedGroupId === 'demographics') {
        insightsTitle = "Households Insights";
    }
    return (_jsxs(_Fragment, { children: [_jsx("h3", { className: `${SECTION_LABEL_CLASS} narrative-heading`, children: insightsTitle }), _jsx("div", { id: "metric-narrative", className: "metric-narrative text-gray-900", "aria-live": "polite", children: narrative === null || narrative === void 0 ? void 0 : narrative.map((paragraph, i) => (_jsx("p", { className: "fs-base", children: paragraph.map((segment, j) => {
                        // Bold is authored emphasis, so it renders as
                        // <strong> and carries to screen readers; the
                        // highlight on a value is presentational and stays
                        // a styled <span>. A run can be both.
                        const Tag = segment.bold ? 'strong' : 'span';
                        if (!segment.bold && !segment.highlight) {
                            return _jsx(React.Fragment, { children: segment.text }, j);
                        }
                        return (_jsx(Tag, { className: segment.highlight ? 'text-primary fw-bolder' : undefined, children: segment.text }, j));
                    }) }, i))) })] }));
};
export default MetricNarrative;
